export const LOCALSTORAGE_LOCATION_HISTORY_ANON = 'LocationService.History.Anonymous';
export const LOCALSTORAGE_LOCATION_HISTORY_SESSION = 'LocationService.History.Session';

// stores previously used locations to local storage in browser
export function storeResolvedLocationsToLocalStorage(previouslyResolvedLocations, isLoggedInUser) {
  if (typeof window !== 'undefined' || window.localStorage !== undefined) {
    const localStorageKey = isLoggedInUser ? LOCALSTORAGE_LOCATION_HISTORY_SESSION : LOCALSTORAGE_LOCATION_HISTORY_ANON;

    window.localStorage.setItem(localStorageKey, JSON.stringify(previouslyResolvedLocations));
  }
}
